module.exports = __webpack_public_path__ + "static/media/icon-crypto.7ba21db2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-crypto.svg
// module id = 254
// module chunks = 0